export const uiAddToSlackSection = {
    name: 'UI Add to Slack Section',
    description: '',
    displayField: null,
    fields: {
        buttonText: {
            name: 'Button Text',
            type: 'RichText',
            required: true,
            localized: true,
            disabled: false,
            omitted: false,
            validations: [
                { nodes: {} },
                {
                    enabledMarks: ['bold', 'italic', 'underline'],
                    message: 'Only bold, italic, and underline marks are allowed'
                },
                { enabledNodeTypes: [], message: 'Nodes are not allowed' }
            ]
        },
        loginText: {
            name: 'Login Text',
            type: 'RichText',
            required: true,
            localized: true,
            disabled: false,
            omitted: false,
            validations: [{ nodes: {} }]
        },
        selectTeamText: {
            name: 'Select Team Text',
            type: 'RichText',
            required: true,
            localized: true,
            disabled: false,
            omitted: false,
            validations: [{ nodes: {} }]
        },
        adminText: {
            name: 'Admin Text',
            type: 'RichText',
            required: true,
            localized: true,
            disabled: false,
            omitted: false,
            validations: [{ nodes: {} }]
        },
        noTeamText: {
            name: 'No Team Text',
            type: 'RichText',
            required: true,
            localized: true,
            disabled: false,
            omitted: false,
            validations: [{ nodes: {} }]
        }
    }
};
//# sourceMappingURL=uiAddToSlackSection.js.map